import { memo, useState } from 'react'
import { useTranslation } from "react-i18next"
import FormErrors from 'components/formParts/formErrors'
import Section from "components/layout/section"
import useAuth from 'hooks/useAuth'
import useLayout from 'hooks/useLayout'
import { logger } from '@/utils/secureLogger'
import { decodeFirebaseError } from '@/utils/firebaseHelpers'
import Form from '@/components/forms/form'
import Button from '@/components/inputs/button'
import ProcessingButton from '@/components/inputs/processingButton'

const AccountDeleteAvatarForm = () => {
    const { t } = useTranslation()
    
    // Form status
    const [errors, setErrors] = useState<string[]>([])
    
    // Auth hooks
    const { deleteAvatar, isDeletingAvatar } = useAuth()
    
    // Layout hooks
    const { addToast } = useLayout()
    
    // Handle form submission
    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault()
        setErrors([])
        
        try {
            await deleteAvatar()
            addToast({ text: t('toastAvatarDeleted'), colorScheme: 'green' })
        } catch (error: any) {
            logger.error('Avatar deletion error', error, 'AccountDeleteAvatar')
            const errorMessage = decodeFirebaseError(error?.code || error?.message || 'Unknown error')
            setErrors([errorMessage])
            addToast({ text: t('toastAvatarDeleteError'), colorScheme: 'red' })
        }
    }
    
    return (
        <Form
            onSubmit={handleSubmit}
            className="group"
            isLoading={isDeletingAvatar}
        >
            <Section>
                <p>{t('deleteAvatarDescription')}</p>
                <div className="input-holder">
                    {isDeletingAvatar ? <ProcessingButton design="danger" /> : <Button wideOnMobile
                        type="submit"
                        design="danger"
                    >
                        {t('buttonDeleteAvatar')}
                    </Button>}
                </div>
            </Section>
            {errors.length > 0 && <FormErrors errors={errors} />}
        </Form>
    )
}

export default memo(AccountDeleteAvatarForm)
